import React from "react";
import { Helmet } from "react-helmet";
import BreadcrumbArea from "../../components/BreadcrumbArea/BreadcrumbArea";
import ConsultationAreaTwo from "../../components/Consultation/ConsultationAreaTwo";
import CounterAreaThree from "../../components/CounterArea/CounterAreaThree";
import InnerServicesArea from "../../components/ServicesArea/InnerServicesArea";
import SuccessArea from "../../components/SuccessArea/SuccessArea";
import TestimonialAreaFour from "../../components/Testimonial/TestimonialAreaFour";
import Layout from "../../layouts/Layout";

const AboutUs = () => {
  return (
    <Layout header={1} footer={1} className="" mainClassName="">
      <Helmet>
        <title>Over Ons | Vernu Stoffering</title>
        <meta
          name="description"
          content="Leer Vernu Stoffering kennen: Specialist in meubelstoffering en herstoffering, waar vakmanschap en maatwerk centraal staan."
        />
        <meta
          name="keywords"
          content="over ons, vernu stoffering, meubelstoffering, herstoffering, projectstoffering"
        />
        <meta property="og:title" content="Over Ons | Vernu Stoffering" />
        <meta
          property="og:description"
          content="Vakmanschap en duurzame stoffering sinds dag één. Vernu Stoffering voor particulieren en bedrijven."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.vernustoffering.nl/about-us" />
        <meta property="og:image" content="https://www.vernustoffering.nl/img/logo/logo.png" />
      </Helmet>

      <BreadcrumbArea
        title="Over Ons"
        subtitle={"Over Ons"}
        className={"pt-175 pb-140"}
      />
      <CounterAreaThree />
      {/* <TeamAreaTwo /> */}
      <ConsultationAreaTwo />
      <InnerServicesArea />
      <SuccessArea />
      {/* <HistoryArea /> */}
      <TestimonialAreaFour />
      {/* <BrandAreaTwo className={"pb-120"} /> */}
    </Layout>
  );
};

export default AboutUs;
